import WorkerDescription from "./WorkerDescription";

export default WorkerDescription;
